import { VuexHelper } from '@amarkets/atlas/esm/lib/vuex-helper';
import createActions from './phone/actions';
import state from './phone/state';
import mutations from './phone/mutations';
import getters from './phone/getters';

export default function (context) {
  return VuexHelper.createStoreModule({
    states: [state],
    actions: [createActions(context)],
    mutations: [mutations],
    getters: [getters],
  });
}
